import React, { Component } from 'react';
import './../css/About.css';
import HeadindStyle from './HeadingStyle';
import TechStack from './../images/TechStack.PNG';
import TsLV from './../images/tslv.PNG';

class About extends Component {
  render() {
    return (
      <div className="container about">
        <p id="hi">Hi!</p>
        <br />
        <p id="description">
          I am Likita Rai, a college student interested in Web Development. Applying creative ways
          to make websites really fascinates me. I have worked on several live projects which has
          constantly upgraded my skills.
        </p>
        <HeadindStyle uppertext="Education" lowertext="Academics" />
        <p id="description">
          Lalbhai DalpatBhai College of Engineering, Ahmedabad
          <br />
          B.E. in Information Technology
          <br />
          2019-2023
        </p>
        <HeadindStyle uppertext="Tech" lowertext="Tech Stack" />
        <img src={TechStack} className="img-fluid TSmobile" alt="Tech Stack" />
        <img src={TsLV} className="img-fluid TSlaptop" alt="Tech Stack" />
        <HeadindStyle uppertext="Experience" lowertext="Profile" />
        <div
          style={{
            padding: '10px',
            marginBottom: '2px',
          }}
        >
          <div>
            <h4>Material UI</h4>
          </div>
          <div>
            <h6>Open Source Contributer</h6>
          </div>
          <div>
            <i>May, 2021 - Jun, 2021</i>
          </div>
          <ul>
            <li>
              Refined the direction and spacing props and added row column spacing props to have
              better control over the component when screen resolution changes.
            </li>
            <li>Also worked on documentation updates.</li>
            <li>Learned Material UI in depth.</li>
          </ul>
        </div>
        <div
          style={{
            padding: '10px',
            marginBottom: '2px',
          }}
        >
          <div>
            <h4>MentoMeet</h4>
          </div>
          <div>
            <h6>Web Developer Intern</h6>
          </div>
          <div>
            <i>Nov, 2020 - Jan, 2021</i>
          </div>
          <ul>
            <li>
              Created "Talk to Mentor" feature along with a team of 4 where mentees could schedule a
              Google Meet with mentors.
            </li>
            <li>
              Developed a Mock Test portal where users can attempt JEE mock test and can view their
              result in dashboard.
            </li>
            <li>Acquired experience in MERN stack.</li>
          </ul>
        </div>
        <div
          style={{
            padding: '10px',
            marginBottom: '2px',
          }}
        >
          <div>
            <h4>Coder's Club</h4>
          </div>
          <div>
            <h6>Web Developer Intern</h6>
          </div>
          <div>
            <i>Aug, 2020 - Oct, 2021</i>
          </div>
          <ul>
            <li>
              Created a platform where students can refer lecture materials conducted by coder's
              club, attempt quiz, enroll in different upcoming courses.
            </li>
            <li>Got significant knowledge about backend work in PHP.</li>
          </ul>
        </div>
      </div>
    );
  }
}

export default About;
